/* eslint-disable react/prop-types */
import theme from '@theme';
import { useAccordionButton } from 'react-bootstrap';
import styled from 'styled-components';

interface AccordionToggle {
  children: React.ReactNode;
  disabled?: boolean;
  eventKey: string;
  primary?: boolean;
  accordionToggleRef?: React.RefObject<HTMLButtonElement>;
  onClick?: () => void;
}

const AccordionToggle: React.FC<AccordionToggle> = ({
  children,
  disabled = false,
  eventKey,
  primary,
  accordionToggleRef,
  onClick
}) => {
  const handleClick = useAccordionButton(eventKey, (event) => {
    event.preventDefault();
    onClick?.();
  });

  return primary ? (
    <PrimaryButton ref={accordionToggleRef} onClick={handleClick} disabled={disabled}>
      {children}
    </PrimaryButton>
  ) : (
    <SecondaryButton ref={accordionToggleRef} onClick={handleClick} disabled={disabled}>
      {children}
    </SecondaryButton>
  );
};

const ButtonBase = styled.button`
  border: none;
  border-radius: 5px;
  font-size: ${theme.fonts.size.xs};
  transition: all 0.3s ease, transform 0.3s ease;

  &:disabled {
    background-color: ${theme.palette.grey[400]};
    cursor: not-allowed;
    opacity: 0.6;
  }

  &:disabled:hover {
    background-color: ${theme.palette.grey[500]};
  }
`;

const PrimaryButton = styled(ButtonBase)`
  background-color: transparent;
  padding: 0 0.3125rem;

  &:hover {
    background-color: ${theme.palette.blue[100]};
  }
`;

const SecondaryButton = styled(ButtonBase)`
  background-color: ${theme.palette.blue[500]};
  color: white;
  padding: 0.3125rem 0.625rem;

  &:hover {
    background-color: ${theme.palette.blue[700]};
  }
`;

export default AccordionToggle;
